import create from 'zustand'

const useLoginStore = create(set => ({
  isLoggedIn: false,
  isLoading: false,
  profileImage: undefined,

  setIsLoggedIn: isLoggedIn => {
    let profileImage = undefined
    if (isLoggedIn) {
      profileImage = window.gapi.auth2.getAuthInstance().currentUser.get().getBasicProfile().getImageUrl()
    }
    set({ isLoggedIn, profileImage })
  },
  setIsLoading: isLoading => set({ isLoading }),
}))

export default useLoginStore